import { render, staticRenderFns } from "./TicketBox.vue?vue&type=template&id=1019f994&"
import script from "./TicketBox.vue?vue&type=script&lang=js&"
export * from "./TicketBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports